var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSafety(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3323 68.592C59.4208 67.0484 75.4439 59.3569 76.153 33.425C76.1833 32.3203 75.6068 31.2762 74.6685 30.6923C62.2528 22.9669 46.5262 22.9669 34.1104 30.6923C33.1721 31.2762 32.5957 32.3203 32.6259 33.425C33.335 59.3569 49.3581 67.0484 53.4466 68.592C54.0571 68.8225 54.7218 68.8225 55.3323 68.592Z",
    fill: "url(#paint0_linear_1846_70117)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1846_70117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7698 39.7759L30.7999 40.9016C29.6685 41.5481 28.9619 42.7683 29.0049 44.0707C29.9325 72.1819 49.1953 80.1824 53.5288 81.6296C54.0988 81.8199 54.68 81.8199 55.25 81.6296C59.5836 80.1824 78.8464 72.1819 79.774 44.0707C79.8169 42.7683 79.1104 41.5481 77.979 40.9016L76.0091 39.7759C62.6124 32.1207 46.1664 32.1207 32.7698 39.7759Z",
    fill: "#6AE092",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8895 41.0584L32.8594 39.9327C46.2005 32.3092 62.5784 32.3092 75.9195 39.9327L77.8894 41.0584C78.9648 41.6729 79.6342 42.8317 79.5935 44.0648C79.1312 58.0753 74.1018 67.0609 68.6591 72.724C63.2127 78.3909 57.343 80.7403 55.1928 81.4583C54.66 81.6363 54.1189 81.6363 53.586 81.4583C51.4359 80.7403 45.5661 78.3908 40.1198 72.724C34.677 67.0609 29.6476 58.0753 29.1853 44.0648C29.1446 42.8317 29.814 41.6729 30.8895 41.0584Z",
    stroke: "url(#paint1_linear_1846_70117)",
    strokeWidth: 0.361074
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1068 49.2026C68.114 50.2097 68.114 51.8427 67.1068 52.8499L54.3972 65.5595C53.9135 66.0432 53.2575 66.3149 52.5735 66.3149C51.8895 66.3149 51.2335 66.0432 50.7499 65.5595L43.4872 58.2969C42.48 57.2897 42.48 55.6567 43.4872 54.6495C44.4944 53.6423 46.1274 53.6423 47.1346 54.6495L52.4714 59.9864C52.5278 60.0428 52.6192 60.0428 52.6756 59.9864L63.4595 49.2026C64.4666 48.1954 66.0996 48.1954 67.1068 49.2026Z",
    fill: "url(#paint2_linear_1846_70117)",
    fillOpacity: 0.9,
    stroke: "url(#paint3_linear_1846_70117)",
    strokeWidth: 0.288859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1846_70117",
    x: 21.7403,
    y: 26.7725,
    width: 65.2982,
    height: 62.2616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.63131
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1846_70117"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1846_70117",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1846_70117",
    x1: 42.293,
    y1: 36.1391,
    x2: 89.6439,
    y2: 71.7761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75EDA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#349256"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1846_70117",
    x1: 29.9506,
    y1: 38.9762,
    x2: 92.9756,
    y2: 85.4536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1846_70117",
    x1: 46.5597,
    y1: 55.2254,
    x2: 86.2779,
    y2: 59.9193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1846_70117",
    x1: 43.3101,
    y1: 50.8925,
    x2: 59.5584,
    y2: 56.3086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSafety);
export default __webpack_public_path__ + "static/media/icon-safety.6417f60dd86af2776c36781b23c60c6b.svg";
export { ForwardRef as ReactComponent };